import {Injectable} from '@angular/core';
import Swal from 'sweetalert2';
import {CommonFormService} from './common-form.service';
import {HttpHeaders} from '@angular/common/http';
import {estructuraRespuesta} from '../../../assets/data/diccionario';
import {moduloAmbiente} from '../../../assets/ambiente/ambienteModulo';
import jwt_decode from 'jwt-decode';
import {AbstractControl, FormArray, FormGroup, Validators} from '@angular/forms';
import * as alertify from 'alertifyjs';
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  mdAmbiente: any = {};
  innEstructuraRespuesta: any = {};

  ambiente: string;
  authenticate: string;
  urlTvc: string;
  urlSeguridad: string;
  urlKibana: string;
  urlDatosMaestros: string;
  urlSustento: string;
  urlFinanciero: string;
  urlVenta: string;
  urlPDVInvolves: string;
  urlAdaptive: string;
  urlDistribuidor: string;
  urlEpp: string;
  urlUniforme: string;
  urlPortaCompras: string;
  urlHorasExtra: string;
  urlAutoconsumo: string;
  urlRPlus: string;
  urlVdi: string;
  urlVmi: string;
  urlBascula: string;
  urlPresupuestoComercial: string;
  urlComisiones: string;
  urlIoIndustrias: string;
  urlComedor: string;
  urlNomina: string;
  urlDotaciones: string;
  urlLogistica: string;
  urlSensoresOnlyControl: string;
  urlplm: string;

  //**API KEY CUSTOM */
  apiKeyCustom: string;


  constructor(private commonFormService: CommonFormService,
              private _route: Router) {
    this.innEstructuraRespuesta = estructuraRespuesta.respuesta;
    this.mdAmbiente = moduloAmbiente;
    this.ambiente = this.mdAmbiente.currentEnvironment;
    
    switch (this.ambiente) {
      case this.mdAmbiente.environmentLocal:
        this.authenticate = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.local.authenticate;
        this.urlSeguridad = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.local.urlSeguridad;
        //this.urlTvc = this.mdAmbiente.local.urlTvc;
        this.urlPortaCompras = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlPortaCompras;
        this.urlVmi = this.mdAmbiente.local.ip +this.mdAmbiente.local.urlVmi;
        this.urlDatosMaestros = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlDatosMaestros;
        //this.urlDatosMaestros = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlDatosMaestros;
        this.urlHorasExtra = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlHorasExtra;
        this.urlAutoconsumo = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlAutoconsumo;
        this.urlFinanciero = this.mdAmbiente.local.ip + this.mdAmbiente.desarrollo.urlFinanciero;
        this.urlRPlus = this.mdAmbiente.local.ip + this.mdAmbiente.desarrollo.urlRPlus;
        this.urlVdi = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlVdi;
        this.urlSustento = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlSustento;
        // this.urlDatosMaestros = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlDatosMaestros;
        // this.urlFinanciero = this.mdAmbiente.local.urlFinanciero;
        this.urlVenta = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.local.urlVenta;
        //this.urlVenta = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlVenta;
        // this.urlPDVInvolves = this.mdAmbiente.local.urlPDVInvolves;
        // this.urlAdaptive = this.mdAmbiente.local.urlAdaptive;
        this.urlDistribuidor = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlDistribuidor;
        this.urlPresupuestoComercial = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlPresupuestoComercial;
        this.urlComisiones = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlComisiones;
        // this.urlEpp = this.mdAmbiente.local.urlEpp;
        // this.urlUniforme = this.mdAmbiente.local.urlUniforme;
        this.urlBascula = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlBalanzaApi;
        this.urlAutoconsumo = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlAutoconsumo;
        this.urlIoIndustrias = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlIoIndustrias;

        //this.urlComedor = this.mdAmbiente.local.ip + this.mdAmbiente.local.comedor;
        this.urlComedor = this.mdAmbiente.local.ip + this.mdAmbiente.local.comedor;
        this.urlNomina = this.mdAmbiente.local.ip + this.mdAmbiente.local.nomina;
        this.urlDotaciones = this.mdAmbiente.local.ip + this.mdAmbiente.local.dotacion;
        this.urlTvc = this.mdAmbiente.desarrollo.urlTvc;
        this.urlLogistica = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlLogistica;
        this.urlSensoresOnlyControl = this.mdAmbiente.local.urlSensoresOnlyControl;
        
        this.urlplm = this.mdAmbiente.local.ip + this.mdAmbiente.local.urlPLMRDL;
        break;
      case this.mdAmbiente.environmentDesarrollo:
        this.authenticate = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.authenticate;
        this.urlSeguridad = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlSeguridad;
        this.urlDatosMaestros = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlDatosMaestros;
        //this.urlDatosMaestros = 'http://localhost:8084/' + this.mdAmbiente.desarrollo.urlDatosMaestros;
        this.urlPortaCompras = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlPortaCompras;
        this.urlVmi = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlVmi;
        this.urlHorasExtra = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlHorasExtra;
        this.urlAutoconsumo = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlAutoconsumo;
        //this.urlAutoconsumo = 'http://localhost:8083/' + this.mdAmbiente.desarrollo.urlAutoconsumo;
        this.urlRPlus = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlRPlus;
        this.urlVdi = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlVdi;
        this.urlSustento = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlSustento;
        this.urlFinanciero = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlFinanciero;
        this.urlVenta = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlVenta;
        // this.urlPDVInvolves = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlPDVInvolves;
        // this.urlAdaptive = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlAdaptive;
        this.urlDistribuidor = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlDistribuidor;
        this.urlPresupuestoComercial = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlPresupuestoComercial;
        this.urlComisiones = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlComisiones;
        // this.urlEpp = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlEpp;
        // this.urlUniforme = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlUniforme;
        this.urlTvc = this.mdAmbiente.desarrollo.urlTvc;
        // this.urlKibana = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlKibana;
        this.urlBascula = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlBalanzaApi;
        this.urlIoIndustrias = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlIoIndustrias;

        this.urlComedor = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.comedor;
        this.urlNomina = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.nomina;
        this.urlDotaciones = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.dotacion;

        this.urlLogistica = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlLogistica;
        this.urlSensoresOnlyControl = this.mdAmbiente.desarrollo.urlSensoresOnlyControl;
        
        this.urlplm = this.mdAmbiente.desarrollo.ip + this.mdAmbiente.desarrollo.urlPLMRDL;
        break;
      case this.mdAmbiente.environmentQA:
        this.authenticate = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.authenticate;
        //this.authenticate = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.authenticate;
        this.urlSeguridad = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlSeguridad;
        this.urlDatosMaestros = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlDatosMaestros;
        this.urlPortaCompras = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlPortaCompras;
        this.urlVmi = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlVmi;
        this.urlHorasExtra = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlHorasExtra;
        this.urlAutoconsumo = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlAutoconsumo;
        this.urlPresupuestoComercial = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlPresupuestoComercial;
        this.urlComisiones = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlComisiones;
        this.urlRPlus = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlRPlus;
        this.urlVdi = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlVdi;
        this.urlSustento = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlSustento;
        this.urlFinanciero = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlFinanciero;
        this.urlVenta = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlVenta;
        // this.urlPDVInvolves = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlPDVInvolves;
        // this.urlAdaptive = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlAdaptive;
        this.urlDistribuidor = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlDistribuidor;
        // this.urlEpp = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlEpp;
        // this.urlUniforme = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlUniforme;
        this.urlTvc = this.mdAmbiente.qa.urlTvc;
        // this.urlKibana = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlKibana;
        this.urlBascula = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlBalanzaApi
        this.urlIoIndustrias = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlIoIndustrias;

        this.urlComedor =  this.mdAmbiente.qa.ip + this.mdAmbiente.qa.comedor;
        this.urlNomina = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.nomina;
        this.urlDotaciones = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.dotacion;
        this.urlLogistica = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlLogistica;
        this.urlSensoresOnlyControl = this.mdAmbiente.qa.urlSensoresOnlyControl;

        this.urlplm = this.mdAmbiente.qa.ip + this.mdAmbiente.qa.urlPLMRDL;
        break;
      case this.mdAmbiente.environmentProduccion:
        this.authenticate = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.authenticate;
        this.urlSeguridad = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlSeguridad;
        this.urlDatosMaestros = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlDatosMaestros;
        this.urlPortaCompras = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlPortaCompras;
        this.urlVmi = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlVmi;
        this.urlHorasExtra = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlHorasExtra;
        this.urlAutoconsumo = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlAutoconsumo;
        this.urlPresupuestoComercial = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlPresupuestoComercial;
        this.urlComisiones = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlComisiones;
        this.urlRPlus = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlRPlus;
        this.urlVdi = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlVdi;
        this.urlSustento = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlSustento;
        this.urlFinanciero = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlFinanciero;
        this.urlVenta = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlVenta;
        // this.urlPDVInvolves = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlPDVInvolves;
        // this.urlAdaptive = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlAdaptive;
        this.urlDistribuidor = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlDistribuidor;
        // this.urlEpp = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlEpp;
        // this.urlUniforme = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlUniforme;
        this.urlTvc = this.mdAmbiente.produccion.urlTvc;
        // this.urlKibana = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlKibana;
        this.urlBascula = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlBalanzaApi;
        this.urlIoIndustrias = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlIoIndustrias;
        this.urlComedor =  this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.comedor;
        this.urlNomina = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.nomina;
        this.urlDotaciones = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.dotacion;

        this.urlLogistica = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlLogistica;
        this.urlSensoresOnlyControl = this.mdAmbiente.produccion.urlSensoresOnlyControl;

        this.urlplm = this.mdAmbiente.produccion.ip + this.mdAmbiente.produccion.urlPLMRDL;
        break;
      default:
        break;
    }

  }

  getDecodedAccessToken(): any {
    try {
      return jwt_decode(localStorage.getItem('accessToken'));
    } catch (Error) {
      return null;
    }
  }

  getAuthenticate() {
    const url = `${this.authenticate}`;
    return url;
  }

  getAmbiente() {
    return this.ambiente;
  }

  getDatosMaestros() {
    const url = `${this.urlDatosMaestros}`;
    return url;
  }

  getPortalCompras() {
    const url = `${this.urlPortaCompras}`;
    return url;
  }

  getVmi() {
    const url = `${this.urlVmi}`;
    return url;
  }

  getVenta() {
    const url = `${this.urlVenta}`;
    return url;
  }

  getSustentos() {
    const url = `${this.urlSustento}`;
    return url;
  }

  getFinanciero(query: string) {
    const url = `${this.urlFinanciero}${query}`;
    return url;
  }

  getPDVInvolves() {
    const url = `${this.urlPDVInvolves}`;
    return url;
  }

  getAdaptive() {
    const url = `${this.urlAdaptive}`;
    return url;
  }

  getDistribuidor() {
    const url = `${this.urlDistribuidor}`;
    return url;
  }

  getPresupuestoComercial() {
    const url = `${this.urlPresupuestoComercial}`;
    return url;
  }

  getComisiones() {
    const url = `${this.urlComisiones}`;
    return url;
  }

  getEpp() {
    const url = `${this.urlEpp}`;
    return url;
  }

  getUniforme() {
    const url = `${this.urlNomina}`;
    return url;
  }

  getQuery(query: string) {
    const url = `${this.urlSeguridad}${query}`;
    return url;
  }

  getSeguridad(query: string) {
    const url = `${this.urlSeguridad}${query}`;
    return url;
  }

  getUrlHorasExtra() {
    const url = `${this.urlHorasExtra}`;
    return url;
  }

  getUrlAutoconsumo() {
    const url = `${this.urlAutoconsumo}`;
    return url;
  }

  geturlRPlus() {
    const url = `${this.urlRPlus}`;
    return url;
  }

  geturlVdi() {
    const url = `${this.urlVdi}`;
    return url;
  }

  getUrlIoIndustrias(){
    const url = `${this.urlIoIndustrias}`;
    return url;
  }

  getHeaders(): HttpHeaders {
    let headers;
    if (this.ambiente === 'LOCAL') {
      headers = new HttpHeaders({
        'Authorization': localStorage.getItem('accessToken'),
        /*        'Access-Control-Allow-Credentials': 'true',
                'Access-Control-Allow-Origin': '*'*/
      });
    } else {
      headers = new HttpHeaders({
        'Authorization': localStorage.getItem('accessToken')
      });
    }
    return headers;
  }

  getQueryTvc(query: string) {
    const url = `${this.urlIoIndustrias}${query}`;
    return url;
  }

  //Se agrega funcion similar para no alterar otros metodos que consumir la funcion original
  getQueryTvc_1(query: string) {
    const url = `${this.urlTvc}${query}`;
    return url;
  }
  
  getUrlKibana() {
    const url = `${this.urlKibana}`;
    return url;
  }

  getUrlBascula() {
    const url = `${this.urlBascula}`;
    return url;
  }

  getUrlLogistica() {
    const url = `${this.urlLogistica}`;
    return url;
  }

  getUrlSensoresOnly() {
    const url = `${this.urlSensoresOnlyControl}`;
    return url;
  }

  getUrlPlm() {
    const url = `${this.urlplm}`;
    return url;
  }



  //* ************************************************* */

  formatofecha(parametro: String) {
    let temp = parametro.split('-');
    return temp[2] + '/' + temp[1] + '/' + temp[0];
  }

  getFechaGuion() {
    let date = new Date();
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  formatStadardFecha(value: Date) {
    const mesTemp = value.getMonth() + 1;
    const mes = ('0' + mesTemp.toString()).slice(-2);
    let dia = ('0' + value.getDate().toString()).slice(-2);
    const fechaStringActual = value.getFullYear() + '-' + mes + '-' + dia
    return fechaStringActual;
  }

  calcularHorasLogout() {
    const horaLimit = 2;
    let fechaHoraLogin: any = localStorage.getItem('timeLogin');
    if (fechaHoraLogin === '' || fechaHoraLogin === undefined || fechaHoraLogin === null) {
      localStorage.clear();
      window.location.href = window.location.origin;
    }
    fechaHoraLogin = new Date(fechaHoraLogin);
    let fechaHoraActual = new Date();
    let tiempoMN = (fechaHoraActual.valueOf() - fechaHoraLogin.valueOf()) / 1000 / 60;
    let horas = tiempoMN / 60;
    if (horas > horaLimit) {
      localStorage.clear();
      window.location.href = window.location.origin;
    }
  }

  roundCantDollar(tag, params) {
    if (params.data[tag] == '' || params.data[tag] == null || params.data[tag] == undefined) {
      params.data[tag] = 0;
    }
    let dato = Number.parseFloat(params.data[tag]).toFixed(2);
    return '$ ' + dato;
  }

  roundCantDollarInput(valor) {
    if (valor == '' || valor == null || valor == undefined) {
      valor = 0;
    }
    let dato = Number.parseFloat(valor).toFixed(2);
    return '$ ' + dato;
  }

  formatearPorcentaje(tag, params) {
    let dato = Number.parseFloat(params.data[tag]).toFixed(2);
    return '% ' + dato;
  }

  getCurrentDate() {
    let date = new Date();
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("/");
  }

  getCurrentDateGuion() {
    let date = new Date();
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  getTomorrowDateGuion() {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  // getTomorrowDateGuion(): Date{
  //   let date = new Date();
  //   date.setDate(date.getDate() + 1);
  //   return date;
  // }

  getFechaInput(str: string) {
    str = (str.length > 10) ? str : str + 'T00:00:00';
    let date = new Date(str);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("/");
  }

  getFechaInputFormat(str: string) {
    str = (str.length > 10) ? str : str + 'T00:00:00';
    let date = new Date(str);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  getFechaAdddays(str: string, dias: number) {
    str = (str.length > 10) ? str : str + 'T00:00:00';
    let date = new Date(str);
    date.setDate(date.getDate() + dias);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  getFechaHoraInput(str) {
    let date = new Date(str);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let h = ("0" + (date.getHours())).slice(-2);
    let m = ("0" + date.getMinutes()).slice(-2);
    let s = ("0" + date.getSeconds()).slice(-2);
    let fechaHora = [day, mnth, date.getFullYear()].join("/");
    return fechaHora + ' ' + h + ':' + m + ':' + s;
  }

  getFechaHoraGuionInput(str) {
    let date = new Date(str);
    let mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let h = ("0" + (date.getHours())).slice(-2);
    let m = ("0" + date.getMinutes()).slice(-2);
    let s = ("0" + date.getSeconds()).slice(-2);
    let fechaHora = [date.getFullYear(), mnth, day].join("-");
    return fechaHora + ' ' + h + ':' + m + ':' + s;
  }

  getHoraInput(str) {
    let date = new Date(str);
    let h = ("0" + (date.getHours())).slice(-2);
    let m = ("0" + date.getMinutes()).slice(-2);
    let s = ("0" + date.getSeconds()).slice(-2);
    return [h, m, s].join(":");
  }

  // zoomOut() {
  //   setTimeout(() => {
  //     document.body.style.zoom = "80%"
  //     return false;
  //   }, 900);
  // }

  /*PROCESO DE VDI FRECUENCIA*/
  renderizarFechaFrecuencia(fecha: string, res: any[]) {
    let out: string = "La fecha es:< " + fecha + "> Equivale:  ";
    for (let i = 0; i < res.length; i++) {
      const el = res[i];
      out = out + "(" + el.idFrecuencia + ")=" + el.dscaFrecuencia + "     ";
    }
    out = out + "";
    return out;
  }

  /*DESCARGAR FILE INPUNT BASE64*/
  descargarArchivo(fileName: string, fileBase64: string, type?: string) {
    let name_file = fileName;
    let archivo = fileBase64;
    const dataURI = "data:aplication/plain;base64," + (archivo);
    var a = document.createElement("a");
    a.href = dataURI;
    name_file = (type) ? name_file + '.' + type : name_file;
    a.setAttribute("download", name_file);
    a.click();
  }

  /*DESCARGAR FILE INPUNT BASE64*/
  descargarArchivoV2(fileName: string, fileBase64: string, type?: string) {
    fileName = (type) ? fileName + '.' + type : fileName;
    const byteCharacters = atob(fileBase64);
    const byteNumbers = new Array(fileBase64.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: 'application/octet-stream'});
    const blobURL = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.download = fileName;
    anchor.href = blobURL;
    anchor.click();
    setTimeout(() => {
      URL.revokeObjectURL(blobURL);
    }, 100);
  }

  /*VERIFICA QUE SI CUALQUIER TIPO DE DATO ESTA VACIO */
  isEmpty(arg) {
    return (
      arg == null || // Check for null or undefined
      arg.length === 0 || // Check for empty String (Bonus check for empty Array)
      (typeof arg === 'object' && Object.keys(arg).length === 0) // Check for empty Object or Array
    );
  }

  exportCSV(cabecera: any[], cuerpo: any[], name: string) {
    //EJEMPLO DE INVOCACION NO DESCOMENTAR
    // let cabecera: any[] = [['example']];
    // const data: any[] = [{'clave':'valor'}];
    // let name: string = "data.csv";
    // this.exportCSV(cabecera, data, name);
    cuerpo.forEach((e) => {
      cabecera.push(Object.values(e));
    });
    let listStr = cabecera.map((e) => e.join(";")).join("\n");
    let str = this.deleteDiacriticos(listStr.toString());
    const blob = new Blob([str], {type: "data:text/csv;charset=utf-8,"});
    const blobURL = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.download = name;
    anchor.href = blobURL;
    anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href,].join(":");
    anchor.click();
    setTimeout(() => {
      URL.revokeObjectURL(blobURL);
    }, 100);
  }

  deleteDiacriticos(texto) {
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  getDataUser() {
    return JSON.parse(localStorage.getItem('datosUsuarioLogin'));
  }

  async servicioItemSeleccionado(textoMostrar) {
    const {value: itemValue} = await Swal.fire({
      title: 'Esta seguro que desea seleccionar este producto ' + textoMostrar.toUpperCase(),
      showCancelButton: true,
      confirmButtonText: 'Confirmar'
    });
    if (itemValue) {
      // console.log('presiono ok-->' + textoMostrar);
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 900
      });

      Toast.fire({
        icon: 'success',
        title: textoMostrar
      })
    }
  }

  async showAlertAdvertenciaEliminar(textoMostrar) {
    const {value: itemValue} = await Swal.fire({
      title: 'Esta seguro que desea Elminar este producto ' + textoMostrar.toUpperCase(),
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Confirmar'
    })
    if (itemValue) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 500
      });
      Swal.fire({
        icon: 'success',
        title: 'Registro Eliminado',
        showConfirmButton: false,
        timer: 1000
      })
      return true;
    }
    localStorage.setItem('toasIdEliminar', '0');
    return false;
  }

  mensajeOKVisto(innMensaje, botonConfirmar?: boolean, tiempo = 2000) {
    Swal.fire({
      position: 'top',
      icon: 'success',
      title: innMensaje,
      showConfirmButton: botonConfirmar,
      timer: tiempo
    });
  }

  mensajeOKVistoHtml(innMensaje, contenido, botonConfirmar?: boolean, tiempo = 2000) {
    Swal.fire({
      position: 'top',
      icon: 'success',
      title: innMensaje,
      html: contenido,
      showConfirmButton: botonConfirmar,
      timer: tiempo
    });
  }

  mensajeErrorVisto(innMensaje, botonConfirmar?: boolean, tiempo = 1000, text?: string) {
    Swal.fire({
      position: 'top',
      icon: 'error',
      title: innMensaje,
      html: text,
      showConfirmButton: botonConfirmar,
      timer: tiempo
    });
  }

  mensajeOKToast(innMensaje, timer = 1000) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      timer: timer
    });

    Toast.fire({
      icon: 'success',
      title: innMensaje
    });
  }

  mensajeOKToastDetalle(innMensaje: string, detalle: {numCaso: number, status: string, mensaje: string}[] = [], timer = 2000) {
    const items = detalle.map(d =>
      `<div style="text-align:left; font-size:0.8rem;"><b>Caso ${d.numCaso}</b> [${d.status}] — ${d.mensaje}</div>`
    ).join('');

    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      timer: timer
    });

    Toast.fire({
      icon: 'success',
      title: innMensaje,
      html: items
    });
  }

  mensajeErroToast(innMensaje, timer?: number) {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: (timer == undefined ? 3000 : timer)
    });

    Toast.fire({
      icon: 'error',
      title: innMensaje
    });
  }

  setearListasLocalStore(nombre: string, lista: any[]) {
    if (lista.length > 0) {
      localStorage.setItem(nombre, JSON.stringify(lista));
    } else {
      localStorage.setItem(nombre, '');
    }
  }

  recuperarListasLocalStore(nombre: string): any[] {
    if (localStorage.getItem(nombre) !== null) {
      if (localStorage.getItem(nombre).length > 0) {
        return JSON.parse(localStorage.getItem(nombre));
      } else {
        return [];
      }
    } else {
      return [];
    }

  }

  setearParametroLocalStore(param: string, value: any) {
    localStorage.setItem(param, value);
  }

  getParametroLocalStore(param: string) {
    return localStorage.getItem(param);
  }

  // ALERTAS UTILES CON CONFIRMACION QUE DEVUELVEN TRUE O FALSE
  // cb como parametro es un callback para evaluar la respuesta desde el componente padre
  confirmar(params, cb) {
    Swal.fire({
      title: `${params.title}`,
      text: `${params.text}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, estoy seguro'
    }).then((result) => {
      if (result.value) {
        cb(result.value);
        Swal.fire(
          `${params.action}`,
          `Haz realizado la acción ${params.action} correctamente`,
          'success'
        );
        // this.commonFormService.limpiarYregrear(context);
      }
    });
  }

  //   confirmarAcyncronico(context, params, cb, cbb?) {
  //     Swal.queue([{
  //       title: `${params.title}`,
  //       text: `${params.text}`,
  //       icon: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       confirmButtonText: 'Si, estoy seguro',
  //       showLoaderOnConfirm: true,
  //       preConfirm: () => {
  //         cb().subscribe(res => {
  //           Swal.fire(
  //             `${params.action}`,
  //             `Haz realizado la acción ${params.action} correctamente`,
  //             'success'
  //           );
  //           this.commonFormService.limpiarYregrear(context);
  //           if (cbb) {
  //             cbb();
  //           }
  //           // console.log(res);
  //           return res;
  //         }, (e) => {
  //           console.log(e.error);
  //           let msg = '';
  //           let status = '';

  //           const err = e.error
  //           msg = err.message;
  //           status = e.statusText;

  //           if (e.status === 0) {
  //             msg = 'No hay conexión a internet';
  //           }
  //           if (e.status === 501) {
  //             //  msg = e.error.message;
  //             //  status = e.error.status;
  //             msg = e.error;
  //             status = e.statusText;
  //           }
  //           if (e.status === 500) {
  //             //msg = e.error;
  //             msg = e.error.message;
  //             status = e.statusText;
  //           }
  //           // AQUI MANEJAR LOS OTROS POSIBLES ERRORES PARA CAMBIAR EL MENSAJE
  //           Swal.fire({
  //             icon: 'warning',
  //             title: status,
  //             text: msg,
  //           });
  //         });
  //       }
  //     }]);
  //   }


  // confirmarAcyncronicoSinFormularioGrid(params, cb, cbb?) {
  //   Swal.queue([{
  //     title: `${params.title}`,
  //     text: `${params.text || ''}`,
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#3085d6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Si, estoy seguro',
  //     showLoaderOnConfirm: true,
  //     preConfirm: () => {
  //       cb().subscribe(res => {
  //         Swal.fire(
  //           `${params.action}`,
  //           `Haz realizado la acción ${params.action} correctamente`,
  //           'success'
  //         );
  //         // this.commonFormService.limpiarYregrear(context);
  //         if (cbb) {
  //           cbb();
  //         }
  //         return res;
  //       }, (e) => {
  //         console.log(e.error);
  //         let msg = '';
  //         let status = '';
  //         if (e.status === 0) {
  //           msg = 'No hay conexión a internet';
  //         }
  //         if (e.error.key === '501') {
  //           msg = e.error.message;
  //           status = e.error.status;
  //         }
  //         // AQUI MANEJAR LOS OTROS POSIBLES ERRORES PARA CAMBIAR EL MENSAJE
  //         Swal.fire({
  //           icon: 'warning',
  //           title: status,
  //           text: msg,
  //         });
  //       });
  //     }
  //   }]);
  // }

  confirmarSincronoPromesaColor(params) {
    let color: any;
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        text: `${params.text || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, estoy seguro',
        showLoaderOnConfirm: true,
      }).then(msn => {
        if (msn.value) {
          params.funcion.subscribe((resp) => {
            switch (resp.colorClasificacion) {
              case 'Verde':
                color = 'success';
                break;
              case 'Amarillo':
                color = 'warning';
                break;
              case 'Naranja':
                color = 'error';
                break;
              case 'Rojo':
                color = 'error';
                break;
              default:
                break;
            }
            Swal.fire(
              `${resp.recomendacion}`,
              `Puntaje: ${resp.puntaje} | Codigo: ${resp.codigo}`,
              color
            );
            resolve(resp);
          }, (e) => {
            console.log(e.error);
            let msg = '';
            let status = '';

            const err = e.error
            msg = err.message;
            status = e.statusText;

            if (e.status === 0) {
              msg = 'No hay conexión a internet';
            }
            if (e.status === 501) {
              //  msg = e.error.message;
              //  status = e.error.status;
              msg = e.error;
              status = e.statusText;
            }
            if (e.status === 500) {
              //msg = e.error;
              msg = e.error.message;
              status = e.statusText;
            }
            // AQUI MANEJAR LOS OTROS POSIBLES ERRORES PARA CAMBIAR EL MENSAJE
            Swal.fire({
              icon: 'warning',
              title: status,
              text: msg,
            });
          });
        } else {
          console.log('cancelo');
        }
      });
    });
  }

  async confirmarSincronoPromesa(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        text: `${params.text || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, estoy seguro',
        // showLoaderOnConfirm: true,
      }).then(msn => {
        if (msn.isConfirmed) {
          if (params.loading) {
            params.context.loading = true;
          }
          params.funcion.subscribe((resp) => {
            Swal.fire(
              `${params.action}`,
              `Haz realizado la acción ${params.action} correctamente`,
              'success'
            );
            if (params.regresarForm) {
              this.commonFormService.limpiarYregrear(params.context);
            }
            resolve(resp);
            if (params.loading) {
              params.context.loading = false;
            }
          }, (e) => {
            if (e.status === 204) {
              Swal.fire({
                icon: 'warning',
                title: 'Error',
                text: 'No se encontro una respuesta.',
              });
            }
            if (e.error === null) {
              Swal.fire({
                icon: 'warning',
                title: 'Error',
                text: 'No se encontro una respuesta.',
              });
              return
            }
            let msg = '';
            let status = '';
            if (e.status === 0) {
              msg = 'No hay conexión a internet';
            }
            // si entra por este if es para eliminar pedidos completos
            //if (e.error.key === '423' || e.error.key === '424' || e.error.key === '426' || e.error.key === '401') {
            if (e.error.key === '495' || e.error.key === '498' || e.error.key === '499' || e.error.key === '496') {
              reject(e);
            } else {
              // msg = e.error.message;
              msg = e.error.mensaje;
              status = e.error.status;
              Swal.fire({
                icon: 'warning',
                title: status,
                text: msg,
              });
              if (params.loading !== undefined) {
                params.context.loading = false;
              }
            }
            let mensaje = e.error.respuesta;
            if (typeof (mensaje) === 'string') {
              alertify.error(mensaje);
            }
            if (typeof (mensaje) === 'object' && mensaje != null) {
              for (let i = 0; i < mensaje.length; i++) {
                const e = mensaje[i];
                alertify.error(e.mensaje);
              }
            }
            reject(e);
          });
        } else {
          reject({error: {status: 'CANCEL'}});
          console.log('cancelo');
        }
      });
    });
  }

  async sweetAlertAccionPromiseSAP(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        text: `${params.text || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, estoy seguro',
      }).then(msn => {

        if (!msn.isConfirmed) {
          return reject({error: {status: 'CANCEL'}});
        }

        if (params.loading) params.context[params.loadingTag] = true;

        if (params.overloading) {
          params.context.gridApi.showLoadingOverlay();
        }

        params.funcion.subscribe((resp: any) => {

          Swal.fire(`${params.action}`, `Haz realizado la acción ${params.action} correctamente`, 'success');

          if (params.regresarForm) this.commonFormService.limpiarYregrear(params.context);

          if (params.loading) params.context[params.loadingTag] = false;

          if (params.overloading) {
            params.context[params.overloadingTag].hideOverlay();
          }
          // debugger
          if (resp?.respuesta != null && resp?.respuesta != undefined) {
            if (typeof (resp.respuesta) === 'object' && resp.respuesta != null) {
              for (const el of resp.respuesta) {
                alertify.success(el.mensaje);
              }
            }
          }

          resolve(resp);

        }, (e) => {

          if (params.overloading) {
            params.context[params.overloadingTag].hideOverlay();
          }

          if (e.status === 204) Swal.fire({icon: 'warning', title: 'Error', text: 'No se encontro una respuesta.'});

          if (e.error === null) {
            Swal.fire({icon: 'warning', title: 'Error', text: 'No se encontro una respuesta.'});
            return;
          }

          if (e.error.key === '495' || e.error.key === '498' || e.error.key === '499' || e.error.key === '496') {
            reject(e);
            return;
          }

          Swal.fire({icon: 'warning', title: e.error.status, text: e.error.mensaje});

          if (params.loading) params.context[params.loadingTag] = false;

          const mensaje = e.error.respuesta;

          if (typeof (mensaje) === 'string') alertify.error(mensaje);

          if (typeof (mensaje) === 'object' && mensaje != null) {
            for (const el of mensaje) {
              alertify.error(el.mensaje);
            }
          }
          reject(e);
        });
      });
    });
  }


  async sweetAlertAccionPromiseSAPV2(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        text: `${params.text || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, estoy seguro',
      }).then(msn => {

        if (!msn.isConfirmed) {
          return reject({error: {status: 'CANCEL'}});
        }

        if (params.loading) params.context[params.loadingTag] = true;

        if (params.overloading) {
          params.context.gridApi.showLoadingOverlay();
        }

        params.funcion.subscribe((resp: any) => {

          if (resp?.mensaje != null && resp?.mensaje != undefined) {
            Swal.fire({
              title: `${params.action}`,
              text: `Haz realizado la acción ${resp.mensaje} correctamente`,
              icon: 'success',
              timer: 20000,
              timerProgressBar: true,
            });
          } else {
            Swal.fire({
              title: `${params.action}`,
              text: `Haz realizado la acción ${params.action} correctamente`,
              icon: 'success',
              timer: 20000,
              timerProgressBar: true,
            });
          }



          if (params.regresarForm) this.commonFormService.limpiarYregrear(params.context);

          if (params.loading) params.context[params.loadingTag] = false;

          if (params.overloading) {
            params.context[params.overloadingTag].hideOverlay();
          }
          // debugger
          if (resp?.respuesta != null && resp?.respuesta != undefined) {
            if (typeof (resp.respuesta) === 'object' && resp.respuesta != null) {
              for (const el of resp.respuesta) {
                alertify.success(el.mensaje);
              }
            }
          }

          resolve(resp);

        }, (e) => {

          if (params.overloading) {
            params.context[params.overloadingTag].hideOverlay();
          }

          if (e.status === 204) Swal.fire({icon: 'warning', title: 'Error', text: 'No se encontro una respuesta.'});

          if (e.error === null) {
            Swal.fire({icon: 'warning', title: 'Error', text: 'No se encontro una respuesta.'});
            return;
          }

          if (e.error.key === '495' || e.error.key === '498' || e.error.key === '499' || e.error.key === '496') {
            reject(e);
            return;
          }

          Swal.fire({icon: 'warning', title: e.error.status, text: e.error.mensaje});

          if (params.loading) params.context[params.loadingTag] = false;

          const mensaje = e.error.respuesta;

          if (typeof (mensaje) === 'string') alertify.error(mensaje);

          if (typeof (mensaje) === 'object' && mensaje != null) {
            for (const el of mensaje) {
              alertify.error(el.mensaje);
            }
          }
          reject(e);
        });
      });
    });
  }


  confirmarSincronoPromesaAction(params, cb) {
    Swal.fire({
      title: `${params.title}`,
      text: `${params.text || ''}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, estoy seguro',
      showLoaderOnConfirm: true,
    }).then(msn => {
      if (msn.value) {
        cb();
        Swal.fire(
          `${params.action}`,
          `Se ha enviado al correo de recuperacion del usuario ${params.ruc} correctamente`,
          //`Haz realizado la acción ${params.action} correctamente`,
          // `Por favor guarde el codigo de solicitud..!!`,
          'success'
        );
      } else {
        console.log('cancelo');
      }
    });
  }

  //   confirmarAcyncronicoTVC(context, params, cb, cbb?) {
  //     Swal.queue([{
  //       title: `${params.title}`,
  //       text: `${params.text}`,
  //       type: 'warning',
  //       showCancelButton: true,
  //       confirmButtonColor: '#3085d6',
  //       cancelButtonColor: '#d33',
  //       cancelButtonText: 'Cancelar',
  //       confirmButtonText: 'Si, estoy seguro',
  //       showLoaderOnConfirm: true,
  //       preConfirm: () => {
  //         cb().subscribe(res => {
  //           Swal.fire(
  //             `${params.action}`,
  //             `Haz realizado la acción ${params.action} correctamente`,
  //             'success'
  //           );
  //           //this.commonFormService.limpiarYregrear(context);
  //           if (cbb) {
  //             cbb();
  //           }
  //           //console.log(res);
  //           return res;
  //         }, (e) => {
  //           console.log(e.error);
  //           let msg = '';
  //           let status = '';
  //           if (e.status === 0) {
  //             msg = 'No hay coneccion a internet';
  //           }
  //           if (e.status === 501) {
  //             //  msg = e.error.message;
  //             //  status = e.error.status;
  //             msg = e.error;
  //             status = e.statusText;
  //           }
  //           if (e.status === 500) {
  //             msg = e.error;
  //             status = e.statusText;
  //           }
  //           // AQUI MANEJAR LOS OTROS POSIBLES ERRORES PARA CAMBIAR EL MENSAJE
  //           Swal.fire({
  //             icon: 'warning',
  //             title: status,
  //             text: msg,
  //           });
  //         });
  //       }
  //     }]);
  //   }

  proundDecimal(param, longi) {
    return Number.parseFloat(param).toFixed(longi);
  }

  confirmarSincronoPromesaNormal(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        text: `${params.text || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, estoy seguro',
        showLoaderOnConfirm: true,
      }).then(msn => {
        if (msn.value) {
          let mensaje = `Haz realizado la acción ${params.action} correctamente`;
          if (params.msn != undefined) {
            mensaje = params.msn;
          }
          if (params.loading) {
            params.context.loading = true;
          }
          params.funcion.subscribe((resp) => {
            Swal.fire(
              `${params.action}`,
              mensaje,
              'success'
            );
            resolve(resp);
            if (params.loading) {
              params.context.loading = false;
            }
          }, (e) => {
            // debugger
            console.log(e.error);
            let msg = '';
            let status = '';
            if (e.status === 0) {
              msg = 'No hay conexión a internet';
            }
            if (e.error.key === '495' || e.error.key === '498' || e.error.key === '499' || e.error.key === '496') {
              reject(e);
            } else {
              if (e.status === 400) {
                msg = e.error.mensaje;
                // alertify.error(msg);
              } else {
                msg = e.error.message;
              }
              status = e.error.status;
              Swal.fire({
                icon: 'warning',
                title: status,
                text: msg,
              });
              //Swal.fire({ icon: 'warning', title: 'Error', text: 'No se encontro una respuesta.' });
            }
            reject(e);
            if (params.loading) {
              params.context.loading = false;
            }
          });
        } else {
          console.log('cancelo servicio Utils');
        }
      });
    });
  }

  confirmarSincronoPromesaSinActions(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        text: `${params.text || ''}`,
        html: `${params.html || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: `${params.labelCancelar || 'Cancelar'}`,
        confirmButtonText: 'Sí, estoy seguro',
        showLoaderOnConfirm: false,
      }).then(res => {
        if (res.value) {
          let mensaje = `Haz realizado la acción ${params.action} correctamente`;
          if (params.msn !== undefined) {
            mensaje = params.msn;
          }
          // Swal.fire(
          //   `${params.action}`,
          //   mensaje,
          //   'success'
          // );
          resolve('ok');
        } else {
          // console.log('cancelo servicio Utils');
          reject('cancel');
        }
      });
    });
  }

  confirmarSincronoPromesaDetalle(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        input: 'text',
        text: `${params.text || ''}`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Editar',
        inputValidator: detalle => {
          // Si el valor es válido, debes regresar undefined. Si no, una cadena
          if (!detalle) {
            return "Ingrese la informacion solicitada";
          } else {
            return undefined;
          }
        }
      }).then(result => {
        if (result.value) {
          let mensaje = '';
          if (params.msn !== undefined) {
            mensaje = params.msn;
          }
          params.funcion.subscribe((resp) => {
            Swal.fire(
              `${params.action}`,
              result.value,
              'success'
            );
            resolve(result.value);
          });
        } else {
          if (params.modal) {
            params.context.abrir.click();
          }
        }
      });
    });
  }

  getNumberCurrentWeek() {
    var d: any = new Date();  //Creamos un nuevo Date con la fecha de "this".
    d.setHours(0, 0, 0, 0);   //Nos aseguramos de limpiar la hora.
    d.setDate(d.getDate() + 4 - (d.getDay() || 7)); // Recorremos los días para asegurarnos de estar "dentro de la semana"
    var c: any = new Date(d.getFullYear(), 0, 1);
    return Math.ceil((((d - c) / 8.64e7) + 1) / 7);
  }

  Prop(obj, is, value?) {
    if (typeof is == 'string')
      is = is.split('.');
    if (is.length == 1 && value !== undefined)
      return obj[is[0]] = value;
    else if (is.length == 0)
      return obj;
    else {
      var prop = is.shift();
      //Forge a path of nested objects if there is a value to set
      if (value !== undefined && obj[prop] == undefined) obj[prop] = {}
      return this.Prop(obj[prop], is, value);
    }
  }

  renderTemplateParam(str, obj) {
    return str.replace(/\$\{(.+?)\}/g, (match, p1) => {
      return this.Prop(obj, p1)
    })
  }

  confirmarSincronoPromesaCantidadProducto(params) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        title: `${params.title}`,
        input: 'number',
        text: `${params.text || ''}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Agregar',
        showLoaderOnConfirm: true,
      }).then(msn => {
        if (msn.value) {
          let mensaje = `Haz realizado la acción ${params.action} correctamente`;
          if (params.msn != undefined) {
            mensaje = params.msn;
          }
          params.funcion.subscribe((resp) => {
            Swal.fire(
              `${params.action}`,
              mensaje,
              'success'
            );
            resolve(msn.value);
            if (params.modal) {
              params.context.abrir.click();
            }
          }, (e) => {

            console.log(e.error);
            let msg = '';
            let status = '';
            if (e.status === 0) {
              msg = 'No hay conexión a internet';
            }
            if (e.error.key === '495' || e.error.key === '498' || e.error.key === '499' || e.error.key === '496') {
              reject(e);
            } else {
              msg = e.error.message;
              status = e.error.status;
              Swal.fire({
                icon: 'warning',
                title: status,
                text: msg,
              });
            }
            reject(e);
            if (params.modal) {
              params.context.abrir.click();
            }
          });
        } else {
          console.log('cancelo servicio Utils');
          if (params.modal) {
            params.context.abrir.click();
          }
        }
      });
    });
  }

  readFileContent(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (!file) {
        resolve('');
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = reader.result.toString();
        resolve(text);
      };
      reader.readAsText(file);
    });
  }

  demoIngresarCantidad() {
    Swal.fire({
      title: 'Ingrese Cantidad',
      input: 'number',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'ok',
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        console.log(login);
      }
    }).then((result: any) => {
      if (result.value) {
        this.mensajeOKVisto(result.value, false, 1000);
        return result.value;
      }
    });
  }

  clearFormArray(formArray: FormArray) {
    while (formArray.length !== 0) {
      formArray.removeAt(0)
    }
  }

  alertifyToast(mensaje: string) {
    alertify.error(mensaje);
    // console.log(mensaje);
  }

  alertifyToastOK(mensaje: string) {
    alertify.success(mensaje);
    // console.log(mensaje);
  }

  alertifyToastWar(mensaje: string) {
    alertify.warning(mensaje);
    // console.log(mensaje);
  }

  alertatoastOK(mensaje: string) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });
    Toast.fire({
      icon: "success",
      title: mensaje
    });
  }

  getFormatoFecha(cadena: string) {
    if (cadena !== null && cadena !== undefined && cadena !== '' && Number.parseFloat(cadena) != 0) {
      return cadena.substring(0, 19).replace('T', ' ');
    }
    return cadena;
  }

  IsNull(variable: any): boolean {
    // Verifica si la variable es nula
    if (variable === null) {
      return true;
    }

    // Verifica si la variable está vacía
    if (variable === '') {
      return true;
    }

    // Verifica si la variable está indefinida
    if (variable === undefined) {
      return true;
    }

    // La variable es válida
    return false;
  }

  //  async mensajeErrorToastMixin(mensaje: string, timer?: number, tipo?: SweetAlertIcon) {
  //     const toastMixin = await Swal.mixin({
  //       toast: true,
  //       icon: 'success',
  //       title: 'General Title',
  //       position: 'bottom-right',
  //       showConfirmButton: false,
  //       timer: timer,
  //       timerProgressBar: true,
  //       didOpen: (toast) => {
  //         toast.addEventListener('mouseenter', Swal.stopTimer)
  //         toast.addEventListener('mouseleave', Swal.resumeTimer)
  //       }
  //     });
  //     await toastMixin.fire({
  //       title: mensaje,
  //       icon: tipo
  //     });
  //   }

  viewObjects(data: any) {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        console.log(key + ': ' + data[key]);
      }
    }
  }

  imprimirAtributos(obj: any, nivel: number = 0) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const valor = obj[key];
        if (Array.isArray(valor)) {
          console.log(' '.repeat(nivel * 2) + key + ': ');
          valor.forEach((element: any) => {
            this.imprimirAtributos(element, nivel + 1);
          });
        } else if (typeof valor === 'object' && valor !== null) {
          console.log(' '.repeat(nivel * 2) + key + ': ');
          this.imprimirAtributos(valor, nivel + 1);
        } else {
          console.log(' '.repeat(nivel * 2) + key + ': ' + valor);
        }
      }
    }
  }

// Services Modulo de Comedores
getComedor() {
  const url = `${this.urlComedor}`;
  return url;
}

getNomina() {
  const url = `${this.urlNomina}`;
  return url;
}

getUrlDotacion() {
  const url = `${this.urlDotaciones}`;
  return url;
}

getVariacionPrecio(newprice : number, oldprice : number) {
  if (  newprice == null || oldprice == null || oldprice == 0) {
    return 0;
  }
  if (newprice != oldprice) {
    return (((newprice - oldprice) / oldprice) * 100).toFixed(2);
  }
  return 0;
}


  notificarVariacionPrecio(newprice: number, oldprice: number) {
    //if (this.UltimoPrecio.length === 0) return "";
    let mensaje = "";
    if (   oldprice == null || oldprice == 0) {
      return mensaje;
    }

    const  variacion = this.getVariacionPrecio(newprice,oldprice);

    console.log("Variacion-> {}",variacion);
    if (variacion !== 0){
      mensaje = 'El precio de compra tiene una Variacion <strong>'+variacion+'%</strong>  respecto al precio anterior. ' +
        'Si desea continuar con el proceso de generacion de Orden de compra en SAP, haga clic en ' +
        "'Si, continuar'" +
        ', caso contrario, de clic en ' +
        "'No, excluir esta linea'" +
        ', para no considerar esta linea por el momento.';
    }
    return mensaje;
  }

  async dialogConfirm(mensaje: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      alertify.defaults.transition = "zoom";
      alertify.defaults.theme.ok = "btn btn-primary";
      alertify.defaults.theme.cancel = "btn btn-danger";

      alertify.confirm(mensaje,
        function(){
         // alertify.success('Linea');
          resolve(true);
        },
        function(){
          alertify.error('No se Guardaran los cambios realizados, la linea queda en el estado anterior.');
          resolve(false);
        }).set({title:"Variación Precio"}).set({labels:{ok:'Si, continuar', cancel:'No, excluir la linea'}}).set({theme: { ok: 'btn btn-primary', cancel: 'btn btn-danger'}});
    });
  }


  verificarCamposFaltantes(formulario: any): string[] {
    const camposFaltantes: string[] = [];

    Object.keys(formulario.controls).forEach(controlName => {
      const control = formulario.get(controlName);
      if (control.invalid) {
        camposFaltantes.push(controlName);
      }
    });

    return camposFaltantes;
  }

  concatenarCampos(cadena1: string | null, cadena2: string | null): string {
    const valor1 = cadena1 !== null ? cadena1 : ' ';
    const valor2 = cadena2 !== null ? cadena2 : ' ';

    return valor1 + '\r' +valor2;
  }

  clearFormFields(form: FormGroup) {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      if (control instanceof FormGroup) {
        this.clearFormFields(control);
      } else {
        control.reset();
      }
    });
  }

  resetControl(control: AbstractControl) {
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach(field => {
        const childControl = control.get(field);
        this.resetControl(childControl);
      });
    } else {
      control.reset();
    }
  }

  toggleControlValidation(control: AbstractControl, toggle: boolean) {
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach(field => {
        const childControl = control.get(field);
        this.toggleControlValidation(childControl, toggle);
      });
    } else {
      if (toggle) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  getFechayHoraActual(){
    const now = new Date();

    // Obtenemos el año, mes (sumamos 1 porque getMonth() devuelve 0-11) y día
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Aseguramos que el mes tenga 2 dígitos
    const day = String(now.getDate()).padStart(2, '0'); // Aseguramos que el día tenga 2 dígitos

    // Obtenemos la hora, minuto y segundo
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    // Construimos la fecha en formato 'yyyy-MM-ddTHH:mm:ss'
    let fechaActual = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

    return fechaActual;
  }


  notificacionBloqueo(nameproceos: string, redirect = false) {
    this.mensajeErrorVisto('Solpes DESACTIVADAS', true,5000,'SOLPED de ' + nameproceos + ' Desactivadas..');
    if (redirect) {
      this._route.navigateByUrl('/home');
    }
  }

  getImagenPin(material: string) {
    const urlPin = "https://res.cloudinary.com/dvo1hej43/image/upload/v1756334841/lafabril/productos/";
    return urlPin+material;
  }

  jsonToCsv(data: any[]): string {
    if (!data || !data.length) return '';
    
    const keys = Object.keys(data[0]); // cabeceras
    const csvRows = [];
    csvRows.push(keys.join(','));

    for (const row of data) {     //datos
      const values = keys.map(k => {
        const val = row[k] === null || row[k] === undefined ? '' : row[k];
        return `"${val.toString().replace(/"/g, '""')}"`; // Escapar comillas
      });
      csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
  }

  getHeadersApiKeyCustom(apiKeyCustom): HttpHeaders {
    let headers;

    switch (this.ambiente) {
      case this.mdAmbiente.environmentLocal:
        headers= this.mdAmbiente.local.apiKeyCustom;
        break;
        
      case this.mdAmbiente.environmentDesarrollo:
        headers= this.mdAmbiente.desarrollo.apiKeyCustom;        
        break;

      case this.mdAmbiente.environmentQA:
        headers= this.mdAmbiente.qa.apiKeyCustom
        break;

      case this.mdAmbiente.environmentProduccion:
        headers= this.mdAmbiente.produccion.apiKeyCustom
        break;
    }
      
    return new HttpHeaders({'Authorization': headers});
  }
}
